import {
    useToastController, Toast,
    ToastTitle,
    ToastBody,
    ToastFooter,
    Toaster,
    ToasterProps
} from "@fluentui/react-components";
import { ReactElement } from "react";


class ToasterControll {
    toasterId: string = "cwToaster";

    tag = (prop: ToasterProps): ReactElement => {
        return (
            <Toaster
                toasterId={this.toasterId}
                pauseOnHover
                pauseOnWindowBlur
                timeout={1000}
            />
        );
    }

    success = (title: string, message: string) => {
        const { dispatchToast } = useToastController(this.toasterId);
        dispatchToast(
            <Toast>
                <ToastTitle>{title} </ToastTitle>
                <ToastBody subtitle="Subtitle" > {message} </ToastBody>
                <ToastFooter>
                </ToastFooter>
            </Toast>,
            { intent: "success" }
        );
    }

}

export default ToasterControll;